import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  AppLanguage,
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  SUPPORTED_LANGUAGES,
} from './i18n.models';

@Injectable()
export class I18nLocaleService {
  constructor(private readonly translate: TranslateService) {}

  get currentLanguage(): AppLanguage {
    const language =
      this.translate.currentLang() ?? this.translate.getFallbackLang() ?? DEFAULT_LANGUAGE;

    return language === 'ms' ? 'ms' : 'en';
  }

  get currentLocale(): string {
    return (
      SUPPORTED_LANGUAGES.find((language) => language.code === this.currentLanguage)?.locale ??
      'en-GB'
    );
  }

  formatDate(
    date: Date,
    options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    },
  ): string {
    return date.toLocaleDateString(this.currentLocale, options);
  }

  formatMonthYear(year: number, monthIndex: number): string {
    return this.formatDate(new Date(year, monthIndex, 1), {
      month: 'long',
      year: 'numeric',
    });
  }

  weekdayInitial(day: number, year: number, monthIndex: number): string {
    const date = new Date(year, monthIndex, day);

    return date
      .toLocaleDateString(this.currentLocale, { weekday: 'narrow' })
      .charAt(0)
      .toUpperCase();
  }

  persistLanguage(language: AppLanguage): void {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    document.documentElement.lang = language;
  }
}
